function formatMoney(amount, currency) {
  var format = '{{amount_no_decimals}}';
  var moneyFormat = currency.replace('{{amount_no_decimals}}', amount.toFixed(2));
  return moneyFormat;
}

$(document).on("click",".add-to-box-btn",function(event){
var ProductDisplay = $(this).parents('.add-to-box-btns_list').toggleClass('showbtn');
  event.preventDefault();
  var limitText = $('.product_limit').attr('product-limit');
  var limitproduct = parseFloat(limitText);
  var productName = $(this).parents('.add-to-box-btns_list').attr('variant-name');
   var addItems = parseFloat($('.add-to-box-btns_list.showbtn').length);
  if($(this).parents('.add-to-box-btns_list').hasClass('showbtn')){   
 $(this).next('.box-remove.button').addClass('active').show();
   $(this).hide();
   }else{  
 $(this).prev('.box-add').show();
    $(this).hide();
  }
var variantName = $(this).closest('.add-to-box-btns_list').attr('variant-name');
  if($(this).parents('.add-to-box-btns_list').hasClass('showbtn')){  
   $('.bundle_item').each(function() {
            if ($(this).val() === '') {
                $(this).val(variantName);
                return false; 
            }
        });
  }else{
        $('.bundle_item').each(function() {
            if ($(this).val() === variantName) {
                $(this).val('');
                return false; 
            }
        });
  }
  var totalSum = 0;
  $(".add-to-box-btns_list.showbtn").each(function () {
      var TottalproductPrice = $(this).attr('variant-price');                   
      totalSum += parseFloat(TottalproductPrice);
  });
  var TotalMAount = parseFloat($('.p-price').attr('final-product-price')); 
  var FinaP = totalSum - TotalMAount;
   var Total_Price = formatMoney(FinaP, "Rs. {{amount_no_decimals}}");
$('.custom-page-compare span').text(Total_Price)
  
var Limitdescrese = limitproduct-addItems;
 $('.custom-page-left .limit').text(Limitdescrese);
  
  if(Limitdescrese == 0 ){
    $('.custom-page-compare').show();    
     $('.custom-page-left').hide()
  }else{
     
    $('.custom-page-left .limit').show();   
    $('.custom-page-left').show()
  }
    if(addItems == 0){
    $('.show_more').hide(); 
     
  }else{
     $('.show_more').show();  
  }
  if(addItems == limitproduct ){
    $('.product-form__submit').attr('disabled',false);
      $('.custom-page-compare').show();
  }else{
     $('.custom-page-compare').hide();
     
    $('.product-form__submit').attr('disabled',true);
  }

  if(addItems == limitproduct){
    $('.box-add.button').attr('disabled',true);
    $('.ajax-add').attr('disabled',false);
  }else{
    $('.box-add.button').attr('disabled',false);
    $('.ajax-add').attr('disabled',true);
  }
    // $('.box-remove.button.active').each(function(index){   
  //  var product_Name = $(this).parents('.add-to-box-btns_list').attr('variant-name');
  //    $(`.custom-page-add-btns .product-form input.item${index}`).val(product_Name);
  // })
  $('.main-counter').text('0'+addItems);
});

